import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installTallyLazy } from "./lib/tally";

createRoot(document.getElementById("root")!).render(<App />);

// Lazy-load Tally embed only on first user intent (hover/touch/scroll)
installTallyLazy();
